import { Route, Routes } from 'react-router-dom';

import { Form } from '@/components';
import { ContainerWithSidebars } from '@/components/widgets/t/ContainerWithSidebars/ContainerWithSidebars';
import { NotFoundPage } from '@/pages/not-found';
import { useProjectDetailById } from '@/pages/shared/hooks/useProjectDetailById';

import { useCreatePlotForm } from '../../hooks/usePlotForm';
import { withErrorBoundary } from './components/ErrorBoundary';
import { useDefaultPlotName } from './hooks/useDefaultPlotName';
import { DrawBoundaryPage } from './pages/draw-boundary.page';
import { PickPolygonEntryMethodPage } from './pages/pick-polygon-entry-method.page';
import { QuestionnairePage } from './pages/questionnaire.page';
import { ReviewUploadPage } from './pages/review-upload.page';
import { SuccessPage } from './pages/success.page';
import { UploadPolygonPage } from './pages/upload-polygon.page';

export const LandstewardNewPlotPage = withErrorBoundary(() => {
  const project = useProjectDetailById().data;
  const { defaultPlotName } = useDefaultPlotName();
  const form = useCreatePlotForm({ plot: { name: defaultPlotName, type: project.landtypes_allowed[0] } });

  return (
    <Form {...form}>
      <Routes>
        <Route
          index
          element={
            <ContainerWithSidebars>
              <PickPolygonEntryMethodPage />
            </ContainerWithSidebars>
          }
        />

        <Route
          path='draw-boundary'
          element={
            <ContainerWithSidebars>
              <DrawBoundaryPage />
            </ContainerWithSidebars>
          }
        />
        <Route
          path='questionnaire'
          element={
            <ContainerWithSidebars>
              <QuestionnairePage />
            </ContainerWithSidebars>
          }
        />

        <Route
          path='upload'
          element={
            <ContainerWithSidebars>
              <UploadPolygonPage />
            </ContainerWithSidebars>
          }
        />
        <Route
          path='review'
          element={
            <ContainerWithSidebars>
              <ReviewUploadPage />
            </ContainerWithSidebars>
          }
        />
        <Route
          path='success'
          element={
            <ContainerWithSidebars>
              <SuccessPage />
            </ContainerWithSidebars>
          }
        />

        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </Form>
  );
});
